import {JokeResponse} from "./types";
import {getCloudHost} from "../consts";

export class Api {

  private static instance;

  static getInstance(): Api {
    if (!this.instance) {
      this.instance = new Api();
    }
    return this.instance;
  }

  private constructor() {
  }

  private static readonly URL = getCloudHost() + "/apps/jokes";

  async joke(): Promise<JokeResponse> {
    const json = await fetch(Api.URL).then(resp => resp.json());
    return json as JokeResponse;
  }
}
